<template>
  <div class="home">
    <div class="homeTop" >
      <el-carousel height="971px">
        <el-carousel-item v-for="item in getBannerList" :key="item.id">
          <img width="100%" :src="item.src" alt="">
        </el-carousel-item>
      </el-carousel>
        

      <div class="homeTop2" style=" position: relative;">
        <!-- <img width="100%" src="../../assets/2.jpg" alt=""> -->
        <div class="homeTop2zz">
          <div style="text-align: center;">
            <h2> 消防职业培训学校&nbsp;&nbsp;</h2>
            <span>专业消防、精编教材、实操教学</span>
          </div>
          <div style="display: flex;width: 1200px;margin: 0 auto;font-size: 30px;margin-top: 40px;">
            <p style="display: flex;flex-direction: column;" v-for="item in getNumberConfigList"><span>{{item.title}}</span><i
                style="display: inline-block;width: 100px;height: 4px;background: #fff;margin: 10px auto;"></i><b
                style="font-size: 45px;margin-top: 5px;">{{item.num}}+</b></p>
            <!-- <p style="display: flex;flex-direction: column;"><span>特色课程</span><i
                style="display: inline-block;width: 100px;height: 4px;background: #fff;margin: 10px auto;"></i><b
                style="font-size: 45px;margin-top: 5px;">10+</b></p>
            <p style="display: flex;flex-direction: column;"><span>服务企业</span><i
                style="display: inline-block;width: 100px;height: 4px;background: #fff;margin: 10px auto;"></i><b
                style="font-size: 45px;margin-top: 5px;">10+</b></p>
            <p style="display: flex;flex-direction: column;"><span>学员见证</span><i
                style="display: inline-block;width: 100px;height: 4px;background: #fff;margin: 10px auto;"></i><b
                style="font-size: 45px;margin-top: 5px;">10+</b></p> -->
          </div>
        </div>
      </div>
    </div>
    <component :is="homejieshao"></component>
    <component :is="duiwu"></component>
    <component :is="xiaofang"></component>
    <component :is="peixun"></component>
    <component :is="xinwem"></component>
    <span v-if="testShow" style="position: fixed;right: 0;bottom: 200px;">
      <i class="el-icon-top" style="padding: 13px 15px;color: #fff;background-color: #2589ff;font-size: 20px;"></i>
    </span>
  </div>
</template>


<script>
import homejieshao from "./components/homejieshao.vue";
import duiwu from "./components/duiwu.vue";
import xiaofang from "./components/xiaofang.vue";
import peixun from "./components/peixun.vue";
import xinwem from "./components/xinwem.vue";
export default {
  components: {
    homejieshao,
    duiwu,
    xiaofang,
    peixun,
    xinwem
  },
  name: "Header",
  data() {
    return {
      homejieshao: 'homejieshao',
      duiwu: 'duiwu',
      xiaofang: 'xiaofang',
      peixun: 'peixun',
      xinwem:'xinwem',
      testShow: false,
      testShow2: false,
      num: 0,
      getBannerList:[],
      getNumberConfigList:[]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);//？监听浏览器滚动条滚动
    this.$axios
            .get("system/banner/getBannerList", {})
            .then(res => {
                if (res.code == 0) {
                this.getBannerList = res.data
                } else {
                this.$message.closeAll();
                this.$message.error(res.msg);
                }
            });

            this.$axios
            .get("/system/numberConfig/getNumberConfigList", {})
            .then(res => {
                if (res.code == 0) {
                this.getNumberConfigList = res.data
                } else {
                this.$message.closeAll();
                this.$message.error(res.msg);
                }
            });
  },
  methods: {
    handleScroll() {
      this.currentScroll = window.pageYOffset//表示当前滚动的位置
      console.log(this.currentScroll, 'curr')
      if (this.currentScroll > 100) {
        this.testShow = true
        if (this.num < 1) {
          this.num++
          console.log('1111111111111111')
        }

        // this.testShow = true
        // if (this.testShow ) {

        // }
      } else {
        this.testShow = false
      }
      if (window.innerHeight) {

      }
    },
    
  }
};
</script>

<style lang="less">
.home {
  @keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
 
  /* 应用动画到具有.fade-in类的元素 */
  .fade-in {
    animation: fadeIn 1s ease-in-out forwards;
  }

  .homeTop2 {
    background: rgba(0, 0, 0, 0) url("../../assets/2.jpg") repeat scroll 0 0;
    padding: 215px 0;
  }

  .homeTop2zz {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;

    h2 {
      width: 100%;
      text-align: center;
      font-size: 30px;
      margin-top: 100px;
    }

    p {
      width: 100%;
      text-align: center;
    }
  }



  .tj {
    background-image: url("../../assets/dk.jpg");
    background-size: cover;
    /* 背景图片覆盖整个元素 */
    background-repeat: no-repeat;
    /* 背景图片不重复 */
    background-position: center;
    /* 背景图片居中 */
    width: 100%;
    /* 元素宽度 */
    height: 1040px;
    padding: 60px 0 0;
    position: relative;

    .tj1A {
      padding: 0 20px;
      color: #4c4c4c;
      font-family: 'montserratregular';
      font-size: 24px;
      margin-bottom: 10px;
    }

    .tj1B {
      padding: 0 20px;
      color: #4c4c4c;
      font-family: 'montserratregular';
      font-size: 14px;
    }

    .tj1C {
      padding: 0 20px;
      margin: 50px 0;

      span {
        background: #0086d1;
        color: #fff;
        padding: 8px 20px;
        font-size: 14px;
      }
    }

    .tj1:hover {
      img {
        cursor: pointer;
      }

      .tj1A {
        color: #0086d1;
        cursor: pointer;
      }

      .tj1C {

        span {
          background: #181a1b;
          color: #fff;
          padding: 8px 20px;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }

  .gywm {
    background-image: url("../../assets/gywm.jpg");
    background-size: cover;
    /* 背景图片覆盖整个元素 */
    background-repeat: no-repeat;
    /* 背景图片不重复 */
    background-position: center;
    /* 背景图片居中 */
    width: 100%;
    /* 元素宽度 */
    height: 964px;
    padding: 60px 0 0;
    position: relative;

    .gywmWrapRight {
      span:hover {
        cursor: pointer;
        color: #F5F5F5;
      }
    }
  }

  .anli {
    background-image: url("../../assets/anli.jpg");
    background-size: cover;
    /* 背景图片覆盖整个元素 */
    background-repeat: no-repeat;
    /* 背景图片不重复 */
    background-position: center;
    /* 背景图片居中 */
    width: 100%;
    /* 元素宽度 */
    height: 855px;
    padding: 60px 0 0;
  }

  .hezuo {
    background-image: url("../../assets/hezuo.jpg");
    background-size: cover;
    /* 背景图片覆盖整个元素 */
    background-repeat: no-repeat;
    /* 背景图片不重复 */
    background-position: center;
    /* 背景图片居中 */
    width: 100%;
    /* 元素宽度 */
    height: 855px;
    padding: 60px 0 0;
    position: relative;
  }
}
</style>